import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-hm-modal-simyo-image',
    templateUrl: './hm-modal-simyo-image.component.html',
    styleUrls: ['./hm-modal-simyo-image.component.css'],
    standalone: false
})
export class HmModalSimyoImageComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
